import { createFileRoute } from '@tanstack/react-router';
import { TemplatesPage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/templates')({
  component: TemplatesRoute,
});

function TemplatesRoute() {
  const { orgId } = Route.useParams();
  return <TemplatesPage orgId={orgId} />;
}
